export default __webpack_public_path__ + "static/media/video_cuboid_before.1c5c9be5.mp4";